/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { telemetryGetUnproxiedMcpServerUsage } from "../funcs/telemetryGetUnproxiedMcpServerUsage.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetUnproxiedMcpServerUsageResult } from "../models/components/getunproxiedmcpserverusageresult.js";
import {
  GetUnproxiedMcpServerUsageRequest,
  GetUnproxiedMcpServerUsageSecurity,
} from "../models/operations/getunproxiedmcpserverusage.js";
import { unwrapAsync } from "../types/fp.js";
export type GetUnproxiedMcpServerUsageQueryData =
  GetUnproxiedMcpServerUsageResult;

export function prefetchGetUnproxiedMcpServerUsage(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetUnproxiedMcpServerUsageRequest,
  security?: GetUnproxiedMcpServerUsageSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetUnproxiedMcpServerUsageQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetUnproxiedMcpServerUsageQuery(
  client$: GramCore,
  request: GetUnproxiedMcpServerUsageRequest,
  security?: GetUnproxiedMcpServerUsageSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetUnproxiedMcpServerUsageQueryData>;
} {
  return {
    queryKey: queryKeyGetUnproxiedMcpServerUsage({
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function getUnproxiedMcpServerUsageQueryFn(
      ctx,
    ): Promise<GetUnproxiedMcpServerUsageQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(telemetryGetUnproxiedMcpServerUsage(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetUnproxiedMcpServerUsage(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return [
    "@gram/client",
    "telemetry",
    "getUnproxiedMcpServerUsage",
    parameters,
  ];
}
